import { SuggestedPromptChips } from "../../jan/components/molecules/SuggestedPromptChips";
import type { SuggestedPrompt } from "../../jan/types";

// Mirrors the clinician homepage suggested prompts. Hardcoded for now, but
// the clinician version fetches these from a Langfuse-managed backend
// endpoint, but Public Jan keeps the list inline to avoid a new endpoint
// on the unauthenticated surface. Update this array if the homepage list
// changes.
export const PUBLIC_SUGGESTED_PROMPTS: SuggestedPrompt[] = [
  {
    promptName: "learn-just-ask",
    displayLabel: "Learn how to use Just Ask NovoNote",
    order: 1,
  },
  {
    promptName: "treatment-evidence",
    displayLabel: "Find treatment evidence for a presentation",
    order: 2,
  },
  {
    promptName: "practice-policy",
    displayLabel: "Draft a practice policy document",
    order: 3,
  },
  {
    promptName: "ethical-dilemma",
    displayLabel: "Think through an ethical dilemma",
    order: 4,
  },
  {
    promptName: "worksheet-handout",
    displayLabel: "Create a worksheet or client handout",
    order: 5,
  },
  {
    promptName: "polish-document",
    displayLabel: "Help me polish a document or letter",
    order: 6,
  },
  {
    promptName: "assessment-library",
    displayLabel: "Explore the assessment library",
    order: 7,
  },
  {
    promptName: "create-template",
    displayLabel: "Create a template: Notes, letters, documents",
    order: 8,
  },
];

interface Props {
  onPick: (prompt: string) => void;
}

export const PublicSuggestedPrompts = ({ onPick }: Props) => (
  <SuggestedPromptChips
    prompts={PUBLIC_SUGGESTED_PROMPTS}
    on_click={(p) => onPick(p.displayLabel)}
    className="max-w-2xl mx-auto"
  />
);
